import { DocumentationIssueType } from './documentation-issue-type.enum';
import { OrderEntryIssueTypeDomestic } from './order-entry-issue-type-domestic.enum';
import { OrderEntryIssueTypeInternational } from './order-entry-issue-type-international.enum';
import { QualityIssueType } from './quality-issue-type.enum';
import { TemperatureIssueType } from './temperature-issue-type.enum';
import { LargeInstrumentWarehouseIssueType } from './large-instrument-warehouse-issue-type.enum';
import { ItemOrQuantityIssueTypeDomestic } from './item-or-quantity-issue-type-domestic.enum';
import { ItemOrQuantityIssueTypeInternational } from './item-or-quantity-issue-type-international.enum';
import { DamageIssueType } from './damage-issue-type.enum';
import { DeliveryIssueTypeDomestic } from './delivery-issue-type-domestic.enum';
import { DeliveryIssueTypeInternational } from './delivery-issue-type-international.enum';
import { EskerOrderIssueType } from './esker-order-issue-type.enum';
import { InvoiceIssueTypeDomestic } from './invoice-issue-type-domestic.enum';
import { InvoiceIssueTypeInternational } from './invoice-issue-type-international.enum';
import { ProductDatingUponReceiptIssueTypeDomestic } from './product-dating-upon-receipt-domestic.enum';
import { BillingAdjustmentIssueType } from './billing-adjustment-issue-type.enum';
import { ProductDatingUponReceiptIssueTypeInternational } from './product-dating-upon-receipt-international.enum';

export const IssueType = {
    ...DocumentationIssueType,
    ...OrderEntryIssueTypeDomestic,
    ...OrderEntryIssueTypeInternational,
    ...LargeInstrumentWarehouseIssueType,
    ...ItemOrQuantityIssueTypeDomestic,
    ...ItemOrQuantityIssueTypeInternational,
    ...QualityIssueType,
    ...TemperatureIssueType,
    ...DamageIssueType,
    ...DeliveryIssueTypeDomestic,
    ...DeliveryIssueTypeInternational,
    ...EskerOrderIssueType,
    ...InvoiceIssueTypeDomestic,
    ...InvoiceIssueTypeInternational,
    ...ProductDatingUponReceiptIssueTypeDomestic,
    ...BillingAdjustmentIssueType,
    ...ProductDatingUponReceiptIssueTypeInternational
};

export type IssueType =
    | DocumentationIssueType
    | OrderEntryIssueTypeDomestic
    | OrderEntryIssueTypeInternational
    | LargeInstrumentWarehouseIssueType
    | ItemOrQuantityIssueTypeDomestic
    | ItemOrQuantityIssueTypeInternational
    | QualityIssueType
    | TemperatureIssueType
    | DamageIssueType
    | DeliveryIssueTypeDomestic
    | DeliveryIssueTypeInternational
    | EskerOrderIssueType
    | InvoiceIssueTypeDomestic
    | InvoiceIssueTypeInternational
    | ProductDatingUponReceiptIssueTypeDomestic
    | BillingAdjustmentIssueType
    | ProductDatingUponReceiptIssueTypeInternational;
